import { Box } from '@mui/material'
import type { Draft } from 'types/graphql'

const ComposeSlackDraftHeader = ({
  draft,
  setDraft,
}: {
  draft: Draft
  setDraft: (draft: Draft) => void
}) => {
  const _ignore = { draft, setDraft }

  return (
    <Box>
      <Box>ComposeSlackDraftHeader</Box>
    </Box>
  )
}

export default ComposeSlackDraftHeader
